"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_bootstrap_table_next_1 = __importDefault(require("react-bootstrap-table-next"));
const CustomPagination_1 = require("../../../Common/CustomPagination");
const TableSkeleton_1 = __importDefault(require("../../AdminShared/TableSkeleton"));
const user_api_1 = require("../../../../utils/api/user/user.api");
const moment_1 = __importDefault(require("moment"));
const Utils_1 = require("../../../../utils/Utils");
const StatistiquereportingTable = () => {
    const { data, isLoading } = (0, user_api_1.useGetAggregateStatsQuery)({});
    const [page, setPage] = react_1.default.useState(1);
    const [perPage, setPerPage] = react_1.default.useState(200);
    const formatDate = (date) => {
        moment_1.default.locale("fr");
        if (!date)
            return "";
        const dateObj = (0, moment_1.default)(date);
        if (!dateObj.isValid())
            return "";
        return (0, Utils_1.capitalize)(dateObj.format("dddd D MMMM YYYY - HH:mm"));
    };
    const locationFormatter = (cell, row) => {
        if ((row === null || row === void 0 ? void 0 : row.lat) && (row === null || row === void 0 ? void 0 : row.long)) {
            const googleMapsUrl = `https://www.google.com/maps?q=${row.lat},${row.long}`;
            return (react_1.default.createElement("a", { href: googleMapsUrl, target: "_blank", rel: "noopener noreferrer", className: "location-link" }, "Voir la position"));
        }
        return react_1.default.createElement("span", { className: "text-muted" }, "N/A");
    };
    const columns = [
        {
            dataField: "screen",
            text: "Nom de l'écran",
            headerStyle: () => ({
                width: "150px",
                whiteSpace: "normal",
                textAlign: "start",
            }),
        },
        {
            dataField: "session_count",
            text: "Nombre de sessions",
            headerStyle: () => ({
                width: "150px",
                whiteSpace: "normal",
                textAlign: "start",
            }),
        },
        {
            dataField: "lat",
            text: "Localisation",
            formatter: locationFormatter,
            headerStyle: () => ({
                width: "150px",
                whiteSpace: "normal",
                textAlign: "start",
            }),
        },
        {
            dataField: "location",
            text: "Adresse",
            formatter: (cell) => cell || react_1.default.createElement("span", { className: "text-muted" }, "N/A"),
            headerStyle: () => ({
                width: "250px",
                whiteSpace: "normal",
                textAlign: "start",
            }),
        },
        {
            dataField: "first_occurred_at",
            text: "Date de la première visite",
            formatter: (cell) => formatDate(cell),
            headerStyle: () => ({
                width: "200px",
                whiteSpace: "normal",
                textAlign: "start",
            }),
        },
        {
            dataField: "last_occurred_at",
            text: "Date de la dernière visite",
            formatter: (cell) => formatDate(cell),
            headerStyle: () => ({
                width: "200px",
                whiteSpace: "normal",
                textAlign: "start",
            }),
        },
        {
            dataField: "total_minutes",
            text: "Durée totale en mn des sessions",
            formatter: (cell) => (cell ? cell.toFixed(2) : "0"),
            headerStyle: () => ({
                width: "200px",
                whiteSpace: "normal",
                textAlign: "start",
            }),
        },
    ];
    const tableData = ((data === null || data === void 0 ? void 0 : data.data) || []).map((item, index) => (Object.assign(Object.assign({}, item), { _id: `${item.screen || "unknown"}-${index}-${item.first_occurred_at || Date.now()}` })));
    const paginatedData = tableData.slice((page - 1) * perPage, page * perPage);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "admin-table" },
            !!isLoading && react_1.default.createElement(TableSkeleton_1.default, { headers: columns }),
            !isLoading && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_bootstrap_table_next_1.default, { keyField: "_id", data: paginatedData || [], columns: columns, condensed: true, hover: true, wrapperClasses: "table-responsive admin-table" }),
                react_1.default.createElement("div", { className: "custom-pagination-container" },
                    react_1.default.createElement(CustomPagination_1.CustomPagination, { nbPages: tableData === null || tableData === void 0 ? void 0 : tableData.length, page: page, onChange: (page, perPage) => {
                            setPerPage(perPage);
                            setPage(page);
                        }, perPage: perPage })))))));
};
exports.default = StatistiquereportingTable;
